/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Define here models used
 * across app that are not defined by the backend
 **/
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexNoData,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive,
  ApexStates,
  ApexStroke,
  ApexTheme,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis
} from 'ng-apexcharts';
import { Observable } from 'rxjs';

import { User } from '~core/models/auth.models';
import { Organization } from '~core/models/organization.models';
import { ImportTaskResponse } from '~core/models/import-task';
import { LoadListener } from '../utils/rxjs';
import { InvoiceType } from '~core/models/invoice.models';

export enum PageName {
  home = 'home',
  login = 'login',
  signInOTP = 'signInOTP',
  signup = 'signup',
  dashboard = 'dashboard',
  product = 'product',
  saleFormat = 'saleFormat',
  unitMeasure = 'unitMeasure',
  forgotPassword = 'forgotPassword',
  resetPassword = 'resetPassword',
  passwordInit = 'passwordInit',
  ntdVerification = 'ntdVerification',
  publicInvoiceVerification = 'publicInvoiceVerification',
  publicCompanyVerification = 'publicCompanyVerification',
  onboarding = 'onBoarding',
  account = 'account',
  accountProfile = 'accountProfile',
  accountSecurity = 'accountSecurity',
  accountEnterpriseInfos = 'accountEnterpriseInfos',
  users = 'users',
  auditLogs = 'auditLogs',
  ability = 'userAbility',
  importTask = 'importTask',
  establishment = 'establishment',
  salesPoint = 'salesPoint',
  userProfil = 'profil',
  stickers = 'stickers',
  organizationList = 'organizationList',
  organizationInfos = 'organizationInfos',
  organizationInvoices = 'organizationInvoices',
  organizationSecurity = 'organizationSecurity',
  organizationReceipts = 'organizationReceipts',
  invoices = 'invoices',
  invoicesGeneration = 'invoicesGeneration',
  invoicesGenerationCreditNote = 'invoicesGenerationCreditNote',
  customerSupplier = 'customerSupplier',
  invoicesIssuing = 'invoicesIssuing',
  organizationUsers = 'organizationUsers',
  billingEquipments = 'billingEquipments',
  taxList = 'taxList',
  taxRules = 'taxRules',
  dashboardList = 'dashboardList',
  dgiSecurity = 'dgiSecurity',
  receiptList = 'receiptList',
  currencies = 'currencies',
  payments = 'payments',
  taxProfiles = 'taxProfiles',
  taxProfileOrganizations = 'taxProfileOrganizations',
  taxTypes = 'taxTypes'
}

export type GpsCoordinates = {
  lat: number;
  lng: number;
};

export type SettingsTabLink = {
  path: string;
  icon?: string;
  title: string;
};

export type TabLink = {
  path: string;
  icon?: string;
  title: string;
  disabled?: boolean;
  queryParams?: Record<string, string | number | boolean | null | undefined>;
};

export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart: ApexChart;
  colors: string[];
  responsive: ApexResponsive[];
  labels: string[];
  stroke: ApexStroke;
  fill: ApexFill;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  plotOptions: ApexPlotOptions;
  tooltip: ApexTooltip;
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
  theme: ApexTheme;
  states: ApexStates;
  grid: ApexGrid;
  markers: ApexMarkers;
  noData: ApexNoData;
};

export type EnrichedImportTask = {
  organisationListener: LoadListener<Organization | null> | Observable<null>;
  accountListener: LoadListener<User | null> | Observable<null>;
} & ImportTaskResponse;

export type CanComponentDeactivate = {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
};

export type CertificationError = {
  propertyPath: string;
  message: string;
  code?: string;
};

export type CertificationErrorsData = {
  title?: string;
  errors: CertificationError[];
};

export enum CreditNoteType {
  full = 'full',
  partial = 'partial'
}

export type InvoiceTypeConfig = {
  label: string;
  key: InvoiceType;
};

export type IconColor = 'blue' | 'pink' | 'green' | 'teal';
